import { Alert, Avatar, Box, Button, Card, CardContent, Grid, IconButton, MenuItem, Snackbar, TextField, Typography } from "@mui/material"
import { Helmet } from "react-helmet-async"
import { businessCheck } from "../../utils/utils"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import MainCard, { ConfirmationDialog, ShowNoRecordsFound, SnackBarHideDuration, SnackBarTransition, stringAvatar } from "../../utils/ui_utils"
import UserTypeShimmer from "../../utils/ui_components/shimmers/userTypeShimmer"
import { Add, Delete } from "@mui/icons-material"
import UnitsCreateAndUpdateDailog from "./units/unitsDailog"
import { useCreateUnits, useFetchUnits, useImportUnits, useUpdateUnits } from "../../modules/units/unitsHooks"
import { useFetchOutlet } from "../../modules/outlet/outletHooks"
const Units = () => {

    const [selectedOutlet, setSelectedOutlet] = useState('')
    const [outlets, setOutlets] = useState([])
    const [snackbar, setSnackBar] = useState(false)
    const [PopUpMessage, setPopUpMessage] = useState(null)
    const [severity, setSeverity] = useState(null)
    const [unitsDrawerMode, setUnitsDrawerMode] = useState('edit')
    const [unitsDrawerVisibility, setUnitDrawerVisibility] = useState(false)
    const [unitData, setUnitData] = useState(null)
    const [deleteConfirmationVisibility, setDeleteConfirmationVisibility] = useState(false)
    const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } = useFetchOutlet()
    const { unitsFetch, unitsFetchData, unitsFetchError, unitsFetchLoading } = useFetchUnits()
    const { unitsCreate } = useCreateUnits()
    const { unitsUpdate } = useUpdateUnits()
    const { unitsImport } = useImportUnits()

    const handleSnackbarClose = () => {
        setSnackBar(false)
    }

    const toastMessage = (message, severity) => {
        setPopUpMessage(message)
        setSeverity(severity)
        setSnackBar(true)
    }

    const handleOutletChange = (event) => {
        setSelectedOutlet(event.target.value)
        unitsFetch(event.target.value)
    }

    const UnitsListUi = ({ unit }) => (
        <MainCard sx={{
            mt: 1,
            p: 2,
            alignItems: "center",
            transition: "box-shadow 0.3s ease",
            borderRadius: 1,
            '&:hover': {
                boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        }}>
            <Grid container column={6} spacing={1} >
                <Grid item sx={{ mr: 3, display: 'flex', alignItems: 'center' }}>
                    <Avatar {...stringAvatar(unit?.name)} />
                </Grid>
                <Grid item xs md sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid container direction={"column"} sx={{ pl: 1, cursor: 'pointer' }} onClick={() => {
                        setUnitsDrawerMode('edit')
                        setUnitDrawerVisibility(true)
                        setUnitData(unit)
                    }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{unit?.name}</Typography>
                    </Grid>
                </Grid>

                <Grid item textAlign="right" sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                        size="small"
                        color="lightRed"
                        component="span"
                        onClick={() => {
                            setUnitData(unit)
                            setDeleteConfirmationVisibility(true)
                        }}
                    >
                        <Delete fontSize='small' />
                    </IconButton>
                </Grid>
            </Grid>
        </MainCard>
    )

    const history = useNavigate()

    useEffect(() => {
        businessCheck(history)
        let payload = {
            pageNumber: 1,
            limit: 1000
        }
        outletFetch(payload)
    }, [])

    useEffect(() => {
        if (outletFetchData.data?.length > 0) {
            setOutlets(outletFetchData.data);
            setSelectedOutlet(outletFetchData.data[0]?._id)
            unitsFetch(outletFetchData.data[0]._id)
        } else {
            setOutlets([])
            setSelectedOutlet("")
        }
    }, [outletFetchData.data])


    return (
        <>
            <Helmet title="Units" />
            <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                <Grid item xs={9}>
                    <Typography variant="h4" gutterBottom display="inline">
                        Units
                    </Typography>
                </Grid>
                <Grid item>
                    <Button startIcon={<Add />}
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => {
                            if (selectedOutlet != null && selectedOutlet != undefined && selectedOutlet != '') {
                                setUnitDrawerVisibility(true)
                                setUnitsDrawerMode('new')
                                setUnitData(null)
                            }
                            else {
                                toastMessage("Select Outlet", "warning")
                            }
                        }}>
                        Add Unit
                    </Button>
                    <UnitsCreateAndUpdateDailog
                        initialValue={unitData}
                        visible={unitsDrawerVisibility}
                        unitData={unitData}
                        mode={unitsDrawerMode}
                        title={unitsDrawerMode == 'new' ? "Add Unit" : "Edit Unit"}
                        okText={unitsDrawerMode == 'new' ? "Create" : "Update"}
                        onClose={() => {
                            setUnitDrawerVisibility(false)
                        }}
                        onSubmit={(values) => {
                            let Value = _.cloneDeep(values)
                            Value.outlet_id = selectedOutlet
                            if (unitsDrawerMode == 'new') {
                                unitsCreate(Value, (success, error, res) => {
                                    if (success) {
                                        toastMessage(res, "success")
                                        unitsFetch(selectedOutlet)
                                        setUnitDrawerVisibility(false)
                                    } else {
                                        toastMessage(res, "error")
                                    }
                                })
                            }
                            else if (unitsDrawerMode == 'edit') {
                                Value.id = Value._id
                                delete Value._id
                                delete Value.business_id
                                unitsUpdate(Value, (success, error, res) => {
                                    if (success == true) {
                                        toastMessage(res, "success")
                                        unitsFetch(selectedOutlet)
                                        setUnitDrawerVisibility(false)
                                    } else {
                                        toastMessage(res, "error")
                                    }
                                })
                            }
                        }}
                    />
                </Grid>

            </Grid>
            <Grid container spacing={6} style={{ paddingTop: 10 }}>
                <Grid item md={3}>
                    <TextField
                        size="small"
                        label="Outlet"
                        id="outlet"
                        name="outlet"
                        variant="outlined"
                        margin="dense"
                        value={selectedOutlet}
                        onChange={handleOutletChange}
                        select
                        fullWidth
                    >
                        {outlets.map((outlet) => (
                            <MenuItem key={outlet._id} value={outlet._id}>
                                {outlet.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid >
            <Box sx={{ margin: 2 }}>
                <Card raised sx={{ borderRadius: 3 }}>
                    <CardContent>
                        {outletFetchLoading || unitsFetchLoading ? <UserTypeShimmer shimmerCount={[1, 2, 3]} /> : !outletFetchLoading && !unitsFetchLoading && unitsFetchData.data?.length <= 0 ?
                            <Grid container direction={'column'} spacing={6} >
                                <Grid container paddingTop={10} justifyContent={'center'} alignItems={'center'}>
                                    <Grid item >
                                        <Typography variant="h6" gutterBottom display="inline">
                                            No Units Found.
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            onClick={() => {
                                                let body = {
                                                    outlet_id: selectedOutlet,
                                                    units: [
                                                        { name: "PCS" },
                                                        { name: "KG" },
                                                        { name: "PLT" },
                                                        { name: "BOX" },
                                                        { name: "BAG" },
                                                        { name: "LTR" },
                                                        { name: "MTR" },
                                                        { name: "DOZ" },
                                                        { name: "PCK" }
                                                    ]
                                                }
                                                unitsImport(body, (success, error, res) => {
                                                    if (success) {
                                                        toastMessage("Default units created.", "success")
                                                        unitsFetch(selectedOutlet)
                                                    } else {
                                                        toastMessage(res, "error")
                                                    }
                                                })
                                            }}
                                        >
                                            Click here to create default units for this outlet.
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <ShowNoRecordsFound /> :
                                </Grid>
                            </Grid> :
                            <Grid container sx={{ mt: 1 }} columns={18} rowSpacing={3} columnSpacing={3} style={{ paddingTop: 10 }}>
                                {unitsFetchData.data?.map((unit, index) => (
                                    <Grid item xs={6} sm={3} key={index}>
                                        <UnitsListUi unit={unit} />
                                    </Grid>))}
                            </Grid>}
                    </CardContent>
                </Card>
            </Box>
            <Snackbar
                open={snackbar}
                autoHideDuration={SnackBarHideDuration}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={handleSnackbarClose}
                TransitionComponent={SnackBarTransition}
            >
                <Alert onClose={handleSnackbarClose} severity={severity}>
                    {PopUpMessage}
                </Alert>
            </Snackbar>
            <ConfirmationDialog
                visibility={deleteConfirmationVisibility}
                title={"Delete Unit"}
                note={"Do you really want to delete this unit?"}
                okText={"Yes"}
                cancelText={"No"}
                onOk={() => {
                    let value = {
                        id: unitData._id,
                        outlet_id: selectedOutlet,
                        name: unitData.name,
                        delete_status: true
                    }
                    unitsUpdate(value, (success, error, res) => {
                        if (success) {
                            toastMessage("Unit deleted successfully", "success")
                            unitsFetch(selectedOutlet)
                            setDeleteConfirmationVisibility(false)
                        } else {
                            toastMessage("Unit deletion failed", "error")
                        }
                    })
                }}
                onCancel={() => {
                    setDeleteConfirmationVisibility(false)
                }
                }
            />
        </>
    )
}

export default Units